export default __webpack_public_path__ + "static/media/image01.a8b46df4.jpg";